export const OPEN_CURLY_BRACKET = '{';
export const CLOSED_CURLY_BRACKET = '}';
export const OPEN_BRACKET_WITH_NO_PAIR = /(\{)[^}]*({|$)+/;
